@if (body) {
  <content-viewer [content]="body" (docRendered)="handleDocRendered($event)"> </content-viewer>
}
@if (!(currentQuery.length > 0 && currentQuery.length < 3)) {
  <div class="results-count">
    Showing {{ resultsCount }} results
    <span>Search results are generated by AI. <app-link [to]="'/terms-of-service'">Learn more</app-link></span>
  </div>
}
@if (currentQuery.length > 0 && currentQuery.length < 3) {
  <div class="no-results-container">
    <div class="no-results-text error-text">Please enter at least 3 characters to search</div>
  </div>
}
@if (suggestedWord && searchResultResponse?.length === 0) {
  <div class="correction-container">
    <span class="correction-link">
      Did you mean&nbsp;
      <b (click)="applyCorrection(suggestedWord)">{{ suggestedWord }}</b>?
    </span>
  </div>
}

<div class="main-content-row">
  <section class="results-list">
    @if (searchResultResponse?.length > 0) {
      @for (response of searchResultResponse; track response) {
        <app-search-card toType="title"
          [searchCardResponse]="response"
          [isLoading]="isLoading"
          [showSkeleton]="isLoading"
        ></app-search-card>
      }

    }
    @if (currentQuery.length >= 3 && searchResultResponse?.length === 0) {
      <div class="no-results-container">
        <div class="no-results-text">No results</div>
        <div class="no-results-text">
          Try using other terms, use our
          <app-link [to]="meta['solution-finder']?.path" class="no-results-link">Solution Finder, </app-link>
          or
          <app-link [to]="meta['solution-finder']?.contactSupport" class="no-results-link">Contact Support</app-link>
        </div>
      </div>
    }
  </section>
  <section class="results-sidebar">
    <solution-finder-card [solutionFinderResponse]="meta['solution-finder']"></solution-finder-card>
    <contact-block class="contact-block"> </contact-block>
  </section>
</div>
